import { footerColumns } from '@/mocks/home';

interface SiteFooterProps {
  notify: (msg: string) => void;
}

export default function SiteFooter({ notify }: SiteFooterProps) {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-6">
          <div className="col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-secondary-950">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <div>
                <p className="font-heading text-lg font-black text-background-50">爆瓜福利</p>
                <p className="text-[11px] text-secondary-200">资源包 · 网盘文件 · 素材合集</p>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-secondary-100">
              爆瓜福利资源包、网盘文件与素材内容合集一站整理，热门爆料与吃瓜资料持续更新，找瓜更省心。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {['ri-weibo-fill', 'ri-wechat-fill', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <button
                  key={icon}
                  type="button"
                  aria-label="站点社交入口"
                  onClick={() => notify('社交入口为演示展示')}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-secondary-800 text-background-100 transition-colors hover:bg-accent-500 hover:text-secondary-950"
                >
                  <i className={icon}></i>
                </button>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">
                <a href="/" className="transition-colors hover:text-accent-300">{column.title}</a>
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a href="/" className="text-xs text-secondary-100 transition-colors hover:text-accent-300">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg bg-secondary-950/40 px-4 py-3 text-[11px] leading-relaxed text-secondary-200">
          免责声明：本站为资源信息聚合展示站点，页面内容与下载入口仅供学习交流使用，所有资源版权归原作者所有。
          请勿用于商业用途，如涉侵权请通过联系邮箱告知，我们将第一时间处理。
        </div>

        <div className="mt-6 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 爆瓜福利 · 爆瓜福利资源包下载入口聚合</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="/" className="whitespace-nowrap transition-colors hover:text-accent-300">使用说明</a>
            <a href="/" className="whitespace-nowrap transition-colors hover:text-accent-300">失效反馈</a>
            <a href="/" className="whitespace-nowrap transition-colors hover:text-accent-300">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}